import React from 'react';
import classNames from 'classnames';

import FormFieldError from './FormFieldError';

const FormItem = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  type,
  name,
  label,
  disabled,
  placeholder,
  autoFocus,
}) => (
  <div
    className={classNames('form__item', {
      'form-error': errors[name] && touched[name],
    })}
  >
    {label && (
    <label htmlFor={name}>{label}</label>
    )}

    <input
      type={type}
      name={name}
      onChange={handleChange}
      onBlur={handleBlur}
      value={values}
      disabled={disabled}
      placeholder={placeholder}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
    />

    { errors[name] && touched[name] && (
    <FormFieldError errorMsg={errors[name]} />
    )}

  </div>
);

export default FormItem;
